import { gql } from '@apollo/client';

export const GET_INVIGLATOR_PAPERS = gql`
  mutation getInvigilatorPapers($name: String!) {
    getIngivilatorPapers(name: $name) {
      name
      allocations {
        _id
        date
        session
        time
        allocatedRoom {
          name
          building
          college
          floor
        }
        invigilators {
          name
          _id
        }
      }
    }
  }
`;
